<template>
  <div>
    <div class="d-flex justify-content-center align-items-center w-100 h-100 font-large-2">
      Test
    </div>

    <div>
      {{ test.title }}
      <div v-for="testVal in test.test">
        <label>
          <input type="radio" v-model="rightAnswer" :value="testVal.id" name="test_answer">
          <span>{{testVal.translation}}</span>
        </label>
      </div>
    </div>

    <button :disabled="disableButton" @click="submitAnswer">
      Submit the answer
    </button>

  </div>
</template>

<script>
import {backEndUrl} from '@/helpers/consts';
import letters from "@/api/letters";

export default {
  name: "index",
  data() {
    return {
      test: {},
      backEndUrl,
      rightAnswer: 0,
      disableButton: false,
    }
  },
  methods: {
    submitAnswer() {
      if (!this.disableButton) {
        this.disableButton = true;
        if (this.test.question.id === this.rightAnswer) {
          this.$bvToast.toast('Ура! Вы правильно ответили на вопрос', {
            title: `Все правильно!`,
            variant: 'success',
            solid: true,
          })
        } else {
          this.$bvToast.toast('К сожалению, вы дали неправильный ответ!', {
            title: `Упс... Давайте попробуем ещё раз`,
            variant: 'danger',
            solid: true,
          })
        }
        setTimeout(() => {
          letters.getTest()
          .then(res => {
            this.test = res.data;
            this.test.test = [...this.test.test, this.test.question]
            this.test.test.sort(() => Math.random() - 0.5);
            this.rightAnswer = 0;
           
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.disableButton = false
          })
        }, 3000)
    }
    }
  },
  created() {
    letters.getTest()
        .then(res => {
          this.test = res.data;
          this.test.test = [...this.test.test, this.test.question]
          this.test.test.sort(() => Math.random() - 0.5);
        })
        .catch(err => {
          console.log(err)
        })
  }
}
</script>

<style scoped>
.word {
  padding: 5px 10px;
  border: 1px solid #ffbd3b;
  margin-right: 10px;
}
</style>
